import { render, staticRenderFns } from "./MedicalInformationDataTable.vue?vue&type=template&id=8fc548a6"
import script from "./MedicalInformationDataTable.vue?vue&type=script&lang=js"
export * from "./MedicalInformationDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports